define(
({
  "alert": "Alert",
  "okay": "Okej"
})
);
